/**
 * The css style for the different states is in src/app/global-style.tsx
 */
export const addFocusOutlineListeners = (): void => {
  mouseDownListener();
  keyPressListener();
};

const mouseDownListener = (): void => {
  document.body.addEventListener("mousedown", () => {
    document.body.classList.add("using-mouse");
  });
};

const keyPressListener = (): void => {
  document.body.addEventListener("keydown", (event) => {
    if (event.key === "Tab") {
      document.body.classList.remove("using-mouse");
    }
  });
};
